<ng-template #dupSamplePopup let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Potential Duplicate Samples</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('X click')"></button>
  </div>
  <div class="modal-body">
    <p>There are one or more potential duplicates for the sample information you entered. Please review the list to determine if you should continue.</p>
    <table class="table table-sm table-responsive-md">
      <thead>
        <tr>
          <th scope="col">Last Name</th>
          <th scope="col">First Name</th>
          <th scope="col">MI</th>
          @if (showVACORISNumber) {
            <th scope="col">VACORIS #</th>
          }
          <th scope="col">SSN</th>
          <th scope="col">SID</th>
          <th scope="col">Date of Birth</th>
          <th scope="col">Date Collected</th>
        </tr>
      </thead>
      <tbody>
        <tr class="table-secondary">
          <th [attr.colspan]="showVACORISNumber ? '8' : '7'" class="text-center"><strong>New Sample</strong></th>
        </tr>
        <tr>
          <td>{{ newSample.lastName }}</td>
          <td>{{ newSample.firstName }}</td>
          <td>{{ newSample.middleInitial }}</td>
          @if (showVACORISNumber) {
            <td>{{ newSample.docNumber }}</td>
          }
          <td [innerHtml]="renderSSNs(newSample.ssns)"></td>
          <td>{{ newSample.sid }}</td>
          <td>{{ newSample.dateOfBirth | date: 'M/d/yyyy' }}</td>
          <td>{{ newSample.dateCollected | date: 'M/d/yyyy' }}</td>
        </tr>
        <tr class="table-secondary">
          <th [attr.colspan]="showVACORISNumber ? '8' : '7'" class="text-center"><strong>Potential Duplicate(s)</strong></th>
        </tr>
        @for (duplicateSample of duplicateSamples; track duplicateSample) {
          <tr>
            <td>{{ duplicateSample.lastName }}</td>
            <td>{{ duplicateSample.firstName }}</td>
            <td>{{ duplicateSample.middleInitial }}</td>
            @if (showVACORISNumber) {
              <td>{{ duplicateSample.docNumber }}</td>
            }
            <td [innerHtml]="renderSSNs(duplicateSample.ssns)"></td>
            <td>{{ duplicateSample.sid }}</td>
            <td>{{ duplicateSample.dateOfBirth | date: 'M/d/yyyy' }}</td>
            <td>{{ duplicateSample.dateCollected | date: 'M/d/yyyy' }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="onContinue()">Continue with entry</button>
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Close window</button>
  </div>
</ng-template>
